module.exports = __webpack_public_path__ + "static/img/code.e59e330.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pubmedSearch/code.png
// module id = Eb/0
// module chunks = 1